import userEvent from '@testing-library/user-event';
import React, { useState } from 'react';
import { db, storage, auth } from '../settings/firebase';

export default async function DeletePost(data) {
  await auth.onAuthStateChanged(async user => {
    if (user) {
      if (user.uid === data.recommender) {
        await db.collection('items').doc(data.docId).delete();
        return alert("投稿を削除しました。")
      } else {
        return alert("削除できませんでした。");
      }
    } else {
      return alert("削除できませんでした。");
    }
  })
}